<template>
<ul class="oil-lic-menu">
	<li v-for="(item, index) in list" :key="index" @click="goToLock()">
		{{ item }}
	</li>
</ul>
</template>

<script>
export default {
	data: () => ({
		list: [
			'Exploration. Devellopment and Production History',
			'Basin Level Analysis',
			'Geological Surveys',
			'Block Evaluation',
			'License Terms & Contracts',
			'Midstream',
			'Additional Resources'
		]
	}),
	methods: {
		goToLock() {
			this.$router.push({
				name: 'lock',
				query: {
					...this.$route.query,
					opportunityId: this.$route.params.opportunityId
				}
			})
		}
	}
}
</script>

<style lang="scss">
.oil-lic-menu {
	list-style: none;
	text-align: left;
	color: #3b9fcf;
	padding: 0;

	li {
		background: #141921;
		padding: 10px 20px;
		margin-bottom: 8px;
		font-size: 13px;
		line-height: 13px;
		cursor: pointer;
	}
}
</style>
